import type { App } from 'vue';
import { log } from './log';

/** Keep Vue's consumed production exceptions on the structured logger path. */
export function reportVueError(err: unknown, info: string): void {
    const error = err instanceof Error ? err : null;
    log.error('vue.error_handler', {
        message: error?.message ?? String(err),
        stack: error?.stack,
        info,
    });
}

/** Install the same structured handler on the production app and integration tests. */
export function installVueErrorHandler(app: App): void {
    app.config.errorHandler = (err, _instance, info) => reportVueError(err, info);
}
